import i18n from '@/locales/i18n'
import { ORDERS_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const ORDERS_LIST_ROUTE_NAME = 'ordersList'
export const ORDERS_DETAIL_ROUTE_NAME = 'ordersDetail'

const routes: RouteType[] = [
    {
        path: ORDERS_ROUTES.baseUrl,
        name: ORDERS_LIST_ROUTE_NAME,
        component: () => import('@/views/OrdersView/OrdersListView.vue'),
        meta: {
            title: i18n.global.t('menu.orders'),
            authRequired: true
        }
    },
    {
        path: ORDERS_ROUTES.detailUrl,
        name: ORDERS_DETAIL_ROUTE_NAME,
        component: () => import('@/views/OrdersView/OrderDetailView.vue'),
        meta: {
            title: i18n.global.t('menu.orders'),
            authRequired: true
        }
    }
]

export default routes
